import React from "react";

import './EditFieldGroup.scss';

const EditFieldGroup = props => {
	const {title, children} = props;

	return (
		<div className="editFieldGroup-container">
			<div className="editFieldGroup-title">
				{title}
			</div>
			<div className="editFieldGroup-fields">
				{children}
			</div>
		</div>
	)
};

export default EditFieldGroup;
